var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoVolume(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "23px",
    viewBox: "0 0 34 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1DCE2C59-2801-4A3C-A0F2-2289A8B01E72") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-440.000000, -612.000000)",
    fillRule: "nonzero",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(442.000000, 613.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-39",
    strokeWidth: 2,
    points: "4 7 4 0 26 0 26 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5,20.7255859 L15.5,0",
    id: "Path-40",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5,25.3081055 L15.5,16.6113281",
    id: "Path-40",
    strokeWidth: 2,
    transform: "translate(15.500000, 21.000000) rotate(90.000000) translate(-15.500000, -21.000000) "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-41",
    strokeWidth: 2,
    points: "3.91155137 7 0 14 3.91155137 14 8 14"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-41",
    strokeWidth: 2,
    points: "25.9115514 7 22 14 25.9115514 14 30 14"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoVolume);
export default __webpack_public_path__ + "static/media/ico_volume.d5d4695def3515913ed2350261a57b68.svg";
export { ForwardRef as ReactComponent };